import * as React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";

export default () => (
    <Card>
        <CardHeader title="Gate Opener Admin" />
        <CardContent>Here we can have any content we want</CardContent>
    </Card>
);
